var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNairaSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 272H384V40C384 35.594 380.406 32 376 32S368 35.594 368 40V272H245.039L78.531 35.406C76.531 32.531 72.781 31.281 69.594 32.375C66.25 33.438 64 36.5 64 40V272H8C3.594 272 0 275.594 0 280S3.594 288 8 288H64V472C64 476.406 67.594 480 72 480S80 476.406 80 472V288H236.742L369.469 476.594C371 478.781 373.438 480 376 480C376.812 480 377.625 479.875 378.406 479.625C381.75 478.562 384 475.5 384 472V288H440C444.406 288 448 284.406 448 280S444.406 272 440 272ZM80 272V65.281L225.482 272H80ZM368 446.719L256.299 288H368V446.719Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaSign);
export default __webpack_public_path__ + "static/media/naira-sign.7a0dac24e23fb902a60e0ddc9dfbe75c.svg";
export { ForwardRef as ReactComponent };